/**
 * Template type mappings for different flow triggers and email positions
 */
export const TEMPLATE_TYPES = {
    TIME_FIRST: 'flow_first_time_email',
    CART_ABANDONED_FIRST: 'flow_first_cart_abandoned_email',
    CHECKOUT_FIRST: 'flow_first_email',
    DEFAULT: 'flow_default',
} as const;

/**
 * Trigger event display names
 */
export const TRIGGER_EVENT_NAMES = {
    CHECKOUT: 'purchase',
    CART_ABANDONMENT: 'customer abandons their cart',
    TIME_DEFAULT: 'event triggers',
    TIME_REFERRAL: 'new referral signs up',
    FALLBACK: 'trigger event',
} as const;

/**
 * Variables that should be excluded for specific trigger types
 */
export const EXCLUDED_VARIABLES = {
    TIME_TRIGGER: ['product_name'] as const,
};
